import Table    from '../../../../components/Table';
import View from './ViewCertificado';
import usePermissions from '../../../../hooks/usePermissions';


const td  = [
  {
    label:"Identificación",
    field:"name",
    className:"",
    align:"left",
  },
  {
    label:"Variable",
    field:"variable",
    className:"",
    align:"left",
  },
  {
    label:"Posición",
    field:"posicion",
    className:"",
    align:"left",
  },
  {
    label:"Acción",
    field:"event",
    className:"",
    align:"center",
    event:[
      {
        label:"Ver",
        action:"view",
        component:View,
      },
      {
        label:"Comentarios",
        action:"comments",
        subFixed:"items_certificado_id_",
        component:true,
      },
    ]
  },
]

const Home=(props)=>{
  const permissions     =   usePermissions("clientes","index",{
                                                                skipSearch:"input",
                                                                component:Table,
                                                                td:td,
                                                                create:View,
                                                                subFixed:"/certificado"
                                                              });
  return  permissions.render()
}
export default Home
